import React from 'react';
import { Button } from './Button';
interface CTASectionProps {
  headline: string;
  body: string;
  buttonText: string;
  buttonLink: string;
  variant?: 'default' | 'dark';
}
export function CTASection({
  headline,
  body,
  buttonText,
  buttonLink,
  variant = 'default'
}: CTASectionProps) {
  const bgColor = variant === 'dark' ? 'bg-primary' : 'bg-background';
  const textColor = variant === 'dark' ? 'text-white' : 'text-ink';
  const bodyColor = variant === 'dark' ? 'text-blue-200' : 'text-muted';
  return <section className={`scroll-fade-in-up ${variant === 'dark' ? 'cta-premium-dark' : bgColor} rounded-2xl p-12 text-center border ${variant === 'dark' ? 'border-divider' : 'border-border'} ${variant === 'dark' ? 'texture-grid' : ''}`} data-id="element-37">
      <h2 className={`text-3xl md:text-4xl font-bold ${textColor} mb-4`} data-id="element-38">
        {headline}
      </h2>
      <p className={`text-lg ${bodyColor} max-w-2xl mx-auto mb-8`} data-id="element-39">{body}</p>
      <Button variant="primary" size="lg" to={buttonLink} data-id="element-40">
        {buttonText}
      </Button>
    </section>;
}